module.exports = __webpack_public_path__ + "img/carters_logo.d472e8e5.png";